var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ConnectivityPackage',{directives:[{name:"allowed",rawName:"v-allowed:view",value:(['STAFF']),expression:"['STAFF']",arg:"view"}],attrs:{"bundle":_vm.fttbConnectivityPackage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }